export default "__VITE_ASSET__cUJNLUQK__"